module.exports = __webpack_public_path__ + "static/img/ket-renewal2025.5c21ffa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/ket-renewal2025.jpg
// module id = /RJ4
// module chunks = 0